<div class="card-container">
 
  <div class="card-header-wrapper">
  </div>

  <div class="dashboardLocal">
    <div class="localSelect">
      <kendo-dropdownlist kendoDropDownFilter textField="nome"
        [data]="listItemsLocais" #refLocal valueField="id" [defaultItem]="placeHolder"  (selectionChange)="selectionChange($event)">
      </kendo-dropdownlist>
    </div>
  </div>

  <div class="card-component">
    <kendo-tilelayout [columns]="6" [rowHeight]="200" [resizable]="true" [reorderable]="true">
      <kendo-tilelayout-item [title]="customMsgService.translate('armarios')" [col]="1" [colSpan]="1">

        <kendo-tilelayout-item-body>
          <h2> {{ data.numeroArmarios }}</h2>
          <div>
            <h3> {{ customMsgService.translate('sites') }}: {{ data.numeroLocais}}</h3>
          </div>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <kendo-tilelayout-item [title]="customMsgService.translate('users')" [col]="2" [colSpan]="1">
        <kendo-tilelayout-item-body>
          <h2> {{ data.numeroUtilizadores }}</h2>
          <div>
            <h3> {{ customMsgService.translate('teams') }}: {{ data.numeroEquipas}}</h3>
          </div>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <kendo-tilelayout-item [title]="customMsgService.translate('tools')" [col]="3" [colSpan]="1">
        <kendo-tilelayout-item-body>
          <h2> {{ data.numeroFerrramentas }}</h2>
          <div>
            <h3> {{ customMsgService.translate('tipos') }}: {{ data.numeroTiposFerrramentas}}</h3>
          </div>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>
      <kendo-tilelayout-item [title]="customMsgService.translate('outrosIndicadores')" [col]="4" [colSpan]="3">
        <kendo-tilelayout-item-body>
          <h3>{{ data.outrosIndicadores[0].label }} : {{ data.outrosIndicadores[0].valor }}</h3>
          <h3>{{ data.outrosIndicadores[1].label }} : {{ data.outrosIndicadores[1].valor }}</h3>
          <h3>{{ data.outrosIndicadores[2].label }} : {{ data.outrosIndicadores[2].valor }}</h3>
          <h3>{{ data.outrosIndicadores[3].label }} : {{ data.outrosIndicadores[3].valor }}</h3>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>
      
      <!-- S2-->

      <kendo-tilelayout-item [title]="customMsgService.translate('estadoFerramentas')" [col]="1" [colSpan]="3"
        [rowSpan]="2">
        <kendo-tilelayout-item-body>
          <kendo-chart>
            <kendo-chart-legend position="bottom"></kendo-chart-legend>
            <kendo-chart-series>
              <kendo-chart-series-item type="pie" [autoFit]="autofit" [data]="data.estado" field="valor"
                position="outsideEnd" categoryField="label" [labels]="{ visible: true, content: labelContent }">
              </kendo-chart-series-item>
            </kendo-chart-series>
          </kendo-chart>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <kendo-tilelayout-item [title]="customMsgService.translate('avariasReportadas')" [col]="4" [colSpan]="3"
        [rowSpan]="2">
        <kendo-tilelayout-item-body>
          <kendo-chart>
            <kendo-chart-legend position="bottom"></kendo-chart-legend>
            <kendo-chart-series>
              <kendo-chart-series-item type="pie" [autoFit]="autofit" [data]="data.avarias" field="valor"
                position="outsideEnd" categoryField="label" [labels]="{ visible: true, content: labelContent }">
              </kendo-chart-series-item>
            </kendo-chart-series>
          </kendo-chart>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>


      <kendo-tilelayout-item [title]="customMsgService.translate('ocupacaoArmarios')" [col]="1" [colSpan]="6"
        [rowSpan]="3">
        <kendo-tilelayout-item-body>

          <kendo-chart>
            <kendo-chart-category-axis>
              <kendo-chart-category-axis-item [categories]="data.categories" [min]="chartRange.start" [max]="chartRange.end">
              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
            <kendo-chart-legend position="bottom" orientation="horizontal" [spacing]="70"
              [padding]="{ left: 0, right: 0 }"></kendo-chart-legend>
            <kendo-chart-tooltip>
              <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category" let-label="label">
                <div class="chart-tooltip"> {{ intl.formatNumber(value, 'n') }} %</div>
              </ng-template>
            </kendo-chart-tooltip>
            <kendo-chart-series>
              <kendo-chart-series-item type="column" [data]="data.ocupacaoArmarios" [color]="data.graphColor"></kendo-chart-series-item>
            </kendo-chart-series>
          </kendo-chart>

        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <!-- S3-->
    </kendo-tilelayout>

  </div>
</div>
